

function Footer() {
  return (
    <div className="App">
      {/* footer content */}
      <footer>
        <div className="pull-right">
          Méndez Salud - AC Development <a href="#">Grupo Mendez</a>
        </div>
        <div className="clearfix" />
      </footer>
      {/* /footer content */}

    </div>
  );
}

export default Footer;
